/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticPauseConfig } from '../../models/automatic-pause-config';
import { AutomaticPauseConfigRequest } from '../../models/automatic-pause-config-request';

export interface UpsertStoreAutomaticPauseOrderingConfig$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: AutomaticPauseConfigRequest
}

export function upsertStoreAutomaticPauseOrderingConfig(http: HttpClient, rootUrl: string, params: UpsertStoreAutomaticPauseOrderingConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseConfig>> {
  const rb = new RequestBuilder(rootUrl, upsertStoreAutomaticPauseOrderingConfig.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticPauseConfig>;
    })
  );
}

upsertStoreAutomaticPauseOrderingConfig.PATH = '/stores/{storeId}/automatic-pauses';
